<template>
    <div class="container-fluid">
        <div class="row align-items-center my-3">
            <div class="col">
                <h4 class="m-0">
                    <i class="fas fa-chart-simple me-2"></i>
                    Status Dashboard
                </h4>
            </div>
            <div class="col-auto">
                <router-link to="/logout" class="btn btn-secondary btn-sm">
                    <i class="fas fa-right-from-bracket me-1"></i>
                    Logout
                </router-link>
            </div>
        </div>

        <ul class="nav nav-tabs mb-3">
            <li class="nav-item">
                <a
                    class="nav-link"
                    :class="{ active: activeTab === 'request' }"
                    href="javascript:void(0)"
                    @click="activeTab = 'request'"
                >
                    <ClipboardList :size="18" class="me-1" />
                    Request Status
                </a>
            </li>
            <li class="nav-item">
                <a
                    class="nav-link"
                    :class="{ active: activeTab === 'project' }"
                    href="javascript:void(0)"
                    @click="activeTab = 'project'"
                >
                    <Layers :size="18" class="me-1" />
                    Project Status
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <div
                class="tab-pane"
                :class="{ active: activeTab === 'request' }"
            >
                <request-status-datatable v-if="activeTab === 'request'" :hide-header="true" staff-page />
            </div>
            <div
                class="tab-pane"
                :class="{ active: activeTab === 'project' }"
            >
                <project-status-datatable v-if="activeTab === 'project'" :hide-header="true" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import ProjectStatusDatatable from "@/components/Projects/ProjectStatusDatatable.vue";
import RequestStatusDatatable from "@/components/Requests/RequestStatusDatatable.vue";
import { Layers, ClipboardList } from "lucide-vue-next";

const activeTab = ref("request");
</script>

<style scoped>
.nav-link {
    display: inline-flex;
    align-items: center;
}
</style>
